import React from 'react';
import { Link } from 'react-router-dom';
export function Shop() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-256">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-257">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-258">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-259">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-260">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-261">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-262">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-263">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-264">
          contact
        </a>
      </header>

      {/* Shop content */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-265">
        <p className="lowercase" data-id="element-266">under maintenance</p>
      </section>
    </main>;
}